export default __webpack_public_path__ + "static/media/verified.f747a517.svg";